import { Injectable } from '@angular/core';
import { RegistrationService } from './registration.service';
import _ from 'lodash';
import { ConfigurationService } from './configuration.service';
import { DateUtilityServiceService } from './date-utility-service.service';

@Injectable({
  providedIn: 'root'
})
export class GuestService {
  guestTypes = [];

  constructor(private registrationService: RegistrationService,
    private configService: ConfigurationService,
    private dateService: DateUtilityServiceService) {
    this.getGuestTypesList();
  }

  /**
    * @function GuestService.getGuestTypesList
    * @description Returns the guest types list.
    */
  getGuestTypesList() {
    const promise = new Promise((resolve, reject) => {
      this.configService.fetchConfig().then((config) => {
        this.guestTypes = config.paxTypeNo;
        if (config.error) {
          reject(config.error);
        } else {
          resolve(this.guestTypes);
        }
      });
    });
    return promise;
  }

  /**
   * @function GuestService.selectGuest
   * @description Sets $mtcIsSelected to the guest passed in.
   * @param guest
   */
  selectGuest(guest) {
    let guests = this.registrationService.getGuests([]);
    _.each(guests,  (existing) => {
      existing.$mtcIsSelected = (existing === guest);
    });
  }

  /**
    * @function GuestService.isChild
    * @description Returns whether guest is a child.
    * @param participant
    * @returns {Boolean}
    */
  isChild(participant) {

    if (!participant || !participant.PAXTypeNo) {
      return false;
    }
    let res = _.filter(this.guestTypes, { "value": participant.PAXTypeNo, "display": "Child" }).length !== 0;
    return res;
  }

  getChildMinDate(){
    const promise = new Promise((resolve, reject) => {
      this.configService.fetchConfig().then((config) => {
        var confStartDate = this.dateService.createMoment(config.arrivalDate).toDate();
        resolve(new Date(confStartDate.getFullYear() - 21,
            confStartDate.getMonth(),
            confStartDate.getDate(),
            confStartDate.getHours()));
      });
    });
    return promise;
  }

  getChildMaxDate(){
    const promise = new Promise((resolve, reject) => {
      this.configService.fetchConfig().then((config) => {
        var confStartDate = this.dateService.createMoment(config.arrivalDate).toDate();
        resolve(new Date(confStartDate.getFullYear() - 16,
            confStartDate.getMonth(),
            confStartDate.getDate(),
            confStartDate.getHours()));
      });
    });
    return promise;
  }

  getChildMinDate2(){
    const promise = new Promise((resolve, reject) => {
      this.configService.fetchConfig().then((config) => {
        var confStartDate = this.dateService.createMoment(config.arrivalDate).toDate();
        resolve(new Date(confStartDate.getFullYear() - 16,
            confStartDate.getMonth(),
            confStartDate.getDate(),
            confStartDate.getHours()));
      });
    });
    return promise;
  }

  getChildMaxDate2(){
    const promise = new Promise((resolve, reject) => {
      this.configService.fetchConfig().then((config) => {
        var confStartDate = this.dateService.createMoment(config.arrivalDate).toDate();
        resolve(new Date(confStartDate.getFullYear() - 11,
            confStartDate.getMonth(),
            confStartDate.getDate(),
            confStartDate.getHours()));
      });
    });
    return promise;
  }

  getChildMinDate3(){
    const promise = new Promise((resolve, reject) => {
      this.configService.fetchConfig().then((config) => {
        var confStartDate = this.dateService.createMoment(config.arrivalDate).toDate();
        resolve(new Date(confStartDate.getFullYear() - 11,
            confStartDate.getMonth(),
            confStartDate.getDate(),
            confStartDate.getHours()));
      });
    });
    return promise;
  }

  getChildMaxDate3(){
    const promise = new Promise((resolve, reject) => {
      this.configService.fetchConfig().then((config) => {
        var confStartDate = this.dateService.createMoment(config.arrivalDate).toDate();
        resolve(new Date(confStartDate.getFullYear() - 0,
            confStartDate.getMonth(),
            confStartDate.getDate(),
            confStartDate.getHours()));
      });
    });
    return promise;
  }

  /**
   * @function GuestService.isSpouseSelected
   * @description Returns if guest is a spouse.
   * @param participant
   * @returns {Boolean}
   */
  isSpouseSelected(participant) {
    if (participant && participant.PAXTypeNo) {
      let res = _.filter(this.guestTypes, { "value": participant.PAXTypeNo, "display": "Spouse" }).length !== 0;
      if (res) {
        return !res;
      }
    }
    let guests = this.registrationService.getGuests([]);
    let isselected = false;
    _.each(guests, (guest) => {
      if (guest && guest.PAXTypeNo) {
        let temp = _.filter(this.guestTypes, { "value": guest.PAXTypeNo, "display": "Spouse" }).length !== 0;
        if (temp) {
          isselected = true;
        }
      }
    });
    return isselected;
  }

  /**
   * @function GuestService.getTypeDisplay
   * @description Sets defualt val and returns default val or returns guest type.
   * @param participant
   */
  getTypeDisplay(participant) {
    let defaultVal = "None";
    if (!participant) {
      return defaultVal;
    }
    let type = _.find(this.guestTypes, { value: participant.PAXTypeNo });
    if (participant.PAXTypeNo === 33) {
      return "Home Office Guest";
    } else if (participant.PAXTypeNo === 37) {
      return "Guest Pass (10 & under)";
    } else if (participant.PAXTypeNo === 36) {
      return "Guest Pass (11-15) $235";
    } else if (participant.PAXTypeNo === 32) {
      return "Guest Pass (16-20) $390";
    } else if (participant.PAXTypeNo === 31) {
      return "Guest Pass (21+) $550";
    } else if (participant.PAXTypeNo === 41) {
      return "Board Member Guest";
    } else if (participant.PAXTypeNo === 42) {
      return "Adult Pass (18+) $550";
    } else if (participant.PAXTypeNo === 34) {
      return "Recruit Guest";
    } else if (participant.PAXTypeNo === 51) {
      return "Commonwealth Guest";
    }
    return type ? type.display : defaultVal;
  }
}
